import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

import { Badge } from "@/shared/components/ui/badge";

import { runOutcome } from "../utils/runs";

/** O status de uma execução no histórico: em andamento, concluída, falhou ou cancelada. */
export function JobRunStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const outcome = runOutcome(status);

  if (outcome === "live") {
    return (
      <Badge variant="secondary" className="gap-1 whitespace-nowrap">
        <Loader2 className="h-3 w-3 animate-spin" />
        {t(status === "waiting" ? "jobs.runs.status.waiting" : "jobs.runs.status.running")}
      </Badge>
    );
  }
  if (outcome === "completed") {
    return <Badge className="whitespace-nowrap bg-green-600 hover:bg-green-600">{t("jobs.runs.status.completed")}</Badge>;
  }
  if (outcome === "cancelled") {
    return (
      <Badge variant="outline" className="whitespace-nowrap">
        {t("jobs.runs.status.cancelled")}
      </Badge>
    );
  }
  return (
    <Badge variant="destructive" className="whitespace-nowrap">
      {t("jobs.runs.status.failed")}
    </Badge>
  );
}
